import { Oval } from "react-loader-spinner";

import i18n from "../../constants/i18n";
import getCoreUIStore from "../../stores/core/core-ui-store";
import ET3Div from "../et3-div";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import Et3Text from "../et3-text";
import {
  LOADING_CARD_BORDER,
  LOADING_CARD_GAP,
  LOADING_CARD_HEIGHT,
  LOADING_CARD_RADIUS,
  LOADING_CARD_SHADOW,
  LOADING_CARD_WIDTH,
  LOADING_LABEL_FONT_SIZE,
  LOADING_LABEL_LETTER_SPACING,
  LOADING_SCRIM,
  LOADING_SCRIM_BLUR,
  LOADING_SPINNER_SIZE,
  LOADING_SPINNER_STROKE,
  LOADING_Z_INDEX
} from "./loading-constants";

const Et3Loading = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY } = theme;
  const shouldShow = getCoreUIStore().isAdminLoading.get();

  return !shouldShow ? null : (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={0}
      height={0}
      color={LOADING_SCRIM}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        minWidth: 0,
        height: "100vh",
        minHeight: 0,
        backdropFilter: LOADING_SCRIM_BLUR,
        zIndex: LOADING_Z_INDEX
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="column"
        justifyContent="center"
        alignItems="center"
        withShadow={false}
        width={LOADING_CARD_WIDTH}
        height={LOADING_CARD_HEIGHT}
        color={colors.all.white}
        style={{
          boxSizing: "border-box",
          borderRadius: LOADING_CARD_RADIUS * unitX,
          border: LOADING_CARD_BORDER,
          boxShadow: LOADING_CARD_SHADOW,
          gap: LOADING_CARD_GAP * unitY
        }}
        onClick={() => {}}
      >
        <Oval
          height={LOADING_SPINNER_SIZE * unitX}
          width={LOADING_SPINNER_SIZE * unitX}
          color={colors.all.bondiBlue}
          secondaryColor={colors.all.borderBlue}
          strokeWidth={LOADING_SPINNER_STROKE}
          strokeWidthSecondary={LOADING_SPINNER_STROKE}
          visible={true}
          ariaLabel={i18n.get("LOADING")}
        />
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={LOADING_LABEL_FONT_SIZE}
          text={i18n.get("LOADING")}
          isSpan={false}
          color={colors.all.davysGrey}
          style={{
            margin: 0,
            letterSpacing: LOADING_LABEL_LETTER_SPACING * unitX
          }}
        />
      </ET3Div>
    </ET3Div>
  );
});
export default Et3Loading;
